import '../ReusableComponents.css'
import '../ReusableReflection.css'

export const ReflectionFh = () => {
  return (
    <>
      <div className='BlackHeds'>
        <h2 className='cases_openerText'>Takeaways</h2>
      </div>
      <section className='ReflectionContainer'>
        <div className='InnerContainer reflection'>
          <h4 className='h4 dropCap'>
            This project was especially meaningful because Dr. Blair is my own
            vet, and I wanted the site to capture the personality and care she
            brings to her work. The challenge was balancing scope with
            detail—deciding which flows mattered most and where to focus my
            time. Looking back, starting with mobile-first design would have
            created a smoother foundation across platforms. The key lesson:
            thoughtful prioritization is just as critical as design craft when
            creating experiences that feel both personal and dependable.
          </h4>
        </div>
      </section>
    </>
  )
}
